import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Container, Row, Col, Card, CardBody, Spinner,
  Modal, ModalHeader, ModalBody, Label,
} from 'reactstrap'
import { Person, People } from '@microsoft/mgt-react'
import moment from 'moment'
import TimeGrid from '../../../components/Template/Calendar/TimeGrid'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { getUserAgenda } from '../../../store/ducks/agenda'

class UserAgenda extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedEvent: null,
      eventDialogIsOpen: false,
    }
  }

  componentDidMount() {
    const { getUserAgenda } = this.props

    getUserAgenda()
  }

  getEventBackground = (event) => {
    if (event.isCancelled) return '#999'

    if (event.recurrence) return '#ac39ac'

    if (moment(`${event.end.dateTime}Z`).isBefore(moment())) return '#999'

    return '#0082e6'
  }

  dayOfWeekAsInteger = (day) => ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'].indexOf(day)

  render() {
    const { userAgenda, getUserAgendaIsLoading } = this.props.agenda

    const { selectedEvent, eventDialogIsOpen } = this.state

    if (getUserAgendaIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    if (!getUserAgendaIsLoading && userAgenda) {
      return (
        <div className="page-content">
          {selectedEvent && (
            <Modal
              centered
              isOpen={eventDialogIsOpen}
              toggle={() => this.setState({ eventDialogIsOpen: !eventDialogIsOpen, selectedEvent: null })}
            >
              <ModalHeader toggle={() => this.setState({ eventDialogIsOpen: !eventDialogIsOpen, selectedEvent: null })}>
                Detalhes
              </ModalHeader>
              <ModalBody>
                <div className="mb-3">
                  <Label className="mb-1">
                    Título
                  </Label>
                  <p>
                    {selectedEvent.title}
                  </p>
                </div>

                <hr />

                <Row className="justify-content-between mb-3">
                  <Col className="d-flex flex-column">
                    <Label className="mb-2">
                      Início
                    </Label>
                    <span>
                      {moment(selectedEvent.start).format('ddd, DD/MM/YYYY HH:mm')}
                    </span>
                  </Col>

                  <Col className="d-flex flex-column">
                    <Label className="mb-2">
                      Fim
                    </Label>
                    <span>
                      {moment(selectedEvent.end).format('ddd, DD/MM/YYYY HH:mm')}
                    </span>
                  </Col>
                </Row>

                <hr />

                <Row className="justify-content-between mb-3">
                  <Col>
                    <div className="d-flex flex-column">
                      <Label className="mb-2">
                        Organizador
                      </Label>
                      <Person
                        personQuery={selectedEvent.extendedProps.organizer.emailAddress.address}
                        personCard="click"
                      />
                    </div>
                  </Col>

                  <Col>
                    <div className="d-flex flex-column">
                      <Label className="mb-2">
                        Participantes
                      </Label>
                      <People
                        showMax={5}
                        personCard="click"
                        peopleQueries={
                          selectedEvent.extendedProps.attendees
                            .map(p => p.emailAddress.address)
                            .filter(p => p !== selectedEvent.extendedProps.organizer.emailAddress.address)
                        }
                      />
                    </div>
                  </Col>
                </Row>

                {selectedEvent.extendedProps.onlineMeeting && selectedEvent.extendedProps.onlineMeeting.joinUrl && (
                  <>
                    <hr />
                    <div className="d-flex flex-column mb-1">
                      <Label className="mb-2">
                        Reunião online
                      </Label>
                      <div>
                        <a
                          href={selectedEvent.extendedProps.onlineMeeting.joinUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Acessar sala
                        </a>
                      </div>

                    </div>
                  </>
                )}

              </ModalBody>
            </Modal>
          )}

          <Container fluid>

            <Breadcrumbs
              title="Agenda"
              breadcrumbItems={[]}
            />

            <Row className="mb-3">
              <Col>
                <h4>
                  Calendário
                </h4>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <TimeGrid
                      events={userAgenda.map((event, index) => ({
                        initialView: 'timeGridWeek',
                        editable: true,
                        id: index,
                        allDay: event.isAllDay,
                        title: event.isCancelled ? `Cancelado: ${event.subject.substring(10)}` : event.subject,
                        start: event.isAllDay ? event.start.dateTime : `${event.start.dateTime}Z`,
                        end: event.isAllDay ? event.end.dateTime : `${event.end.dateTime}Z`,
                        daysOfWeek: event.recurrence ? event.recurrence.pattern.daysOfWeek.map(day => this.dayOfWeekAsInteger(day)) : null,
                        startTime: event.recurrence ? moment(`${event.start.dateTime}Z`).format('HH:mm') : null,
                        endTime: event.recurrence ? moment(`${event.end.dateTime}Z`).format('HH:mm') : null,
                        startRecur: event.recurrence ? `${event.start.dateTime}Z` : null,
                        endRecur:
                          event.recurrence ? (
                            event.recurrence && event.recurrence.range && event.recurrence.range.type && event.recurrence.range.type === 'endDate' ? (
                              event.recurrence.range.endDate
                            ) : moment(event.end.dateTime).add(1, 'y').format('YYYY-MM-DD')
                          ) : null,
                        groupId: event.recurrence ? `event-groupId-${index}` : null,
                        extendedProps: event,
                        backgroundColor: this.getEventBackground(event),
                      }))}
                      eventDidMount={info => {
                        info.el.setAttribute('title', info.event.title)
                        if (info.event.extendedProps.isCancelled) {
                          info.el.classList.add('crossed-out-text')
                        }
                      }}
                      eventClick={({ event }) => {
                        this.setState({
                          selectedEvent: event,
                          eventDialogIsOpen: true,
                        })
                      }}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ agenda: state.agenda })
const mapDispatchToProps = dispatch => bindActionCreators({ getUserAgenda }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(UserAgenda)
